<h1>{{ 'settings.companies.companies' | translate }}</h1>
<div fxLayout="row wrap" class="search-area" fxLayoutAlign="space-between start">
  <app-search-companies fxFlex="80"></app-search-companies>
  <div *blockCompanyProfile="['EMB']">
    <button *ngIf="modules.includes(modulePermission.SolicitarNovaEmpresa)" mat-flat-button color="accent" class="button-new-company" routerLink="/Settings/Companies/Request">
      {{ ('settings.companies.request-new-company' | translate).toUpperCase() }}
    </button>
  </div>
</div>
<div *ngIf="modules.includes(modulePermission.VisualizarEmpresas)" class="table">
  <table mat-table [dataSource]="dataSource" class="example-table">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>Id</th>
      <td mat-cell *matCellDef="let element" class="padding-right">CO-{{ element.id }}</td>
    </ng-container>

    <ng-container matColumnDef="companyName">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'settings.companies.company-name' | translate }}
      </th>
      <td mat-cell matTooltip="{{ element.companyName }}" *matCellDef="let element" class="padding-right">
        {{ element.companyName | truncate : 30 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="cnpj">
      <th mat-header-cell *matHeaderCellDef>CNPJ</th>
      <td mat-cell matTooltip="{{ formatCnpj(element.cnpj) }}" *matCellDef="let element" class="padding-right">
        {{ formatCnpj(element.cnpj) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="myRole">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'settings.companies.my-role' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="padding-right">
        {{ 'settings.companies.' + element.role.replace(' ', '-').toLowerCase() | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'settings.companies.country' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="padding-right">
        {{ element.countryName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'settings.companies.status' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="padding-right">
        <div class="status mat-elevation-z4 {{ element.status.toUpperCase() }}" fxLayout="row" fxLayoutAlign="center center">
          {{ 'settings.companies.' + element.status.toLowerCase() | translate }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'settings.companies.actions' | translate }}
      </th>
      <td mat-cell *matCellDef="let company">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <div fxLayout="column" fxLayoutAlign="start start" *ngIf="company.status.toUpperCase() !== 'INVITATION'; else invitation">
            <button *ngIf="!currentCompany(company.id)" mat-menu-item (click)="workAsCompany(company)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <mat-icon> subdirectory_arrow_right </mat-icon>
              <span>{{ 'settings.work-as' | translate }}</span>
            </button>
            <button mat-menu-item [routerLink]="'/Settings/Companies/Detail/' + company.id" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <mat-icon> visibility </mat-icon>
              <span>{{ 'settings.companies.details' | translate }}</span>
            </button>
            <button
              mat-menu-item
              *ngIf="company.status.toUpperCase() !== 'INACTIVE' && company.role.toUpperCase() === 'ADMIN' && modules.includes(modulePermission.AdicionarNovoUsuarioEmpresa)"
              (click)="inviteUser(company.id)"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="8px"
            >
              <mat-icon> person_add_alt_1 </mat-icon>
              <span>{{ 'settings.companies.add-member' | translate }}</span>
            </button>
            <button
              mat-menu-item
              *ngIf="company.status.toUpperCase() !== 'INACTIVE' && company.role.toUpperCase() === 'ADMIN' && modules.includes(modulePermission.EditarEmpresa)"
              [routerLink]="'/Settings/Companies/Edit/' + company.id"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="8px"
            >
              <mat-icon> create </mat-icon>
              <span>{{ 'settings.companies.edit-company' | translate }}</span>
            </button>

            <button
              *ngIf="modules.includes(modulePermission.DeixarEmpresa)"
              mat-menu-item
              (click)="leaveCompanyDialog(company)"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="8px"
            >
              <fa-icon class="icone" [icon]="faSignOutAlt"></fa-icon>
              <span>{{ 'settings.companies.leave-company' | translate }}</span>
            </button>
          </div>
        </mat-menu>
        <ng-template #invitation>
          <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
            <button
              mat-menu-item
              [routerLink]="'/Settings/Companies/Invitation/' + company.id + '/' + company.companyName"
              [matTooltip]="'settings.companies.details' | translate"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="8px"
            >
              <mat-icon> visibility </mat-icon>
              <span>{{ 'settings.companies.details' | translate }}</span>
            </button>
            <button mat-menu-item color="accent" [matTooltip]="'settings.companies.accept-invitation' | translate" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <mat-icon>check_circle</mat-icon>
              <span>{{ 'settings.companies.accept-invitation' | translate }}</span>
            </button>
            <button mat-menu-item color="warn" [matTooltip]="'settings.companies.decline-invitation' | translate" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <mat-icon>cancel</mat-icon>
              <span>{{ 'settings.companies.decline-invitation' | translate }}</span>
            </button>
          </div>
        </ng-template>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator #paginator [length]="count" [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" (page)="pageChange($event)"> </mat-paginator>
</div>
